import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { Flex, Switch, Text } from '@nula/core-ui';
import type { RecordingSettings } from '../../hooks/use-recording-settings';
import styles from './notifications-section.module.css';

export type NotificationsSectionProps = {
  calendarEnabled: boolean;
  onUpdate: (patch: Partial<RecordingSettings>) => void;
  className?: string;
};

const root = cva(styles.root);
const toggle = cva(styles.toggle);
const toggleLabel = cva(styles.toggleLabel);

/**
 * Calendar-notifications toggle. Meeting *detection* (app + browser) moved to
 * `DetectionSourcesSection` when the single Auto-detect toggle was split into
 * two independent sources — calendar reminders are a separate concern from
 * presence detection and carry no Accessibility-permission story.
 */
export function NotificationsSection({
  calendarEnabled,
  onUpdate,
  className,
}: NotificationsSectionProps) {
  return (
    <Flex vertical className={clsx(root(), className)}>
      <Flex className={toggle()}>
        <Flex vertical className={toggleLabel()}>
          <Text size="sm" className={styles.label}>Calendar notifications</Text>
          <Text type="secondary" size="xs">
            Get notified before scheduled meetings.
          </Text>
        </Flex>
        <Switch
          checked={calendarEnabled}
          onChange={(v) => onUpdate({ calendarNotificationsEnabled: v })}
          size="sm"
        />
      </Flex>
    </Flex>
  );
}
